import { OfferScopeOfWorkAddDialogConfig } from "../offer/components/offer-scope-of-work-add-dialog";

export const wrhOfferScopeOfWorkAddDialogConfig: OfferScopeOfWorkAddDialogConfig =
  {
    selectBaseData: false,
    selectServiceVariation: true,
  };
